import React, { useState } from 'react';
import { useQuran } from '../context/QuranContext';
import WordAnalysisPanel from './WordAnalysisPanel';

const WordByWord = ({ words }) => {
    const [selectedWord, setSelectedWord] = useState(null);
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    const handleWordClick = (word) => {
        // Filter out end markers (like verse numbers)
        if (word.char_type_name === 'end') return;
        
        setSelectedWord(word);
        setIsPanelOpen(true);
    };

    const handleClosePanel = () => {
        setIsPanelOpen(false);
        setSelectedWord(null);
    };

    if (!words || words.length === 0) {
        return (
            <div className="translation-panel text-center text-[#94a3b8]" data-testid="no-words">
                No word-by-word data available
            </div>
        );
    }

    // Filter out end markers for display
    const displayWords = words.filter(word => word.char_type_name !== 'end');

    return (
        <>
            <div className="translation-panel" data-testid="word-by-word-container">
                <p className="text-xs uppercase tracking-[0.2em] text-[#94a3b8] mb-4 ui-text font-medium text-center">
                    Click on any word to explore its root and occurrences
                </p>
                
                <div className="word-grid" data-testid="word-grid">
                    {displayWords.map((word, index) => (
                        <div
                            key={word.id || index}
                            className="word-card group"
                            onClick={() => handleWordClick(word)}
                            data-testid={`word-card-${index}`}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && handleWordClick(word)}
                        >
                            {/* Arabic Word */}
                            <span 
                                className="arabic-text text-2xl text-[#f8fafc] group-hover:text-[#d4af37] transition-colors"
                                dir="rtl"
                                lang="ar"
                            >
                                {word.text_uthmani || word.text_indopak || word.text}
                            </span>
                            
                            {/* Transliteration */}
                            {word.transliteration?.text && (
                                <span className="text-sm text-[#94a3b8] italic ui-text">
                                    {word.transliteration.text}
                                </span>
                            )}
                            
                            {/* English Translation */}
                            {word.translation?.text && (
                                <span className="text-sm text-[#e2e8f0] ui-text text-center">
                                    {word.translation.text}
                                </span>
                            )}
                            
                            {/* Position indicator */}
                            <span className="text-xs text-[#475569] ui-text">
                                {word.position}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Word Analysis Panel */}
            <WordAnalysisPanel 
                word={selectedWord}
                isOpen={isPanelOpen}
                onClose={handleClosePanel}
            />
        </>
    );
};

export default WordByWord;
